import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL

export const sendOtpOtherPhone = async (ownerId: string, granteeId: string, scope: string, token: string) => {
    return await axios.post(`${API_URL}v2/chat/admin/access/chat-request`,
        {
            ownerId,
            granteeId,
            scope
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    )
}

export const updateOtherPhone = async (ownerId: string, granteeId: string, scope: string, token: string) => {
    return await axios.post(`${API_URL}v2/chat/admin/access/update`,
        {
            ownerId,
            granteeId,
            scope
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    )
}

export const verifyOtpOtherPhone = async (requestId: string, otp: string, token: string) => {
    return await axios.post(`${API_URL}v2/chat/access/chat-request/validate`,
        {
            requestId,
            otp
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    )
}

export const deleteOtherPhone = async (ownerId: string, granteeId: string, token: string) => {
    return await axios.post(`${API_URL}v2/chat/admin/access/delete`,
        {
            ownerId,
            granteeId,
        },
        {
            headers: {
                'X-Auth-token': token
            }
        }
    )
}